import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { CompanyOwnerDto } from '../types/dtos';
export default (build: EndpointBuilder<BaseQueryFn, string, string>) =>
    build.mutation<void, { id: string; payload: Partial<CompanyOwnerDto> }>({
        query: ({ id, payload }) => ({
            url: `${APP_ENDPOINTS.COMPANY_OWNER}/${id}`,
            method: 'PATCH',
            body: payload,
        }),
        invalidatesTags: [
            { type: 'company-owner', id: 'GET-ID' },
            { type: 'company-owners-with-join', id: 'GET-JOIN' },
            { type: 'company-owners', id: 'GET' },
            { type: 'companies-with-join', id: 'GET-JOIN' },
            { type: 'company', id: 'GET-ID' },
        ],
    });
